import React from 'react';
import { Button, Modal, message } from "antd";
import { useParams } from 'react-router-dom';
import { makeAdmin } from '../useAPIDetails/useFetchUserList'; 

const MakeAdminModal = ({ isModalVisible, setIsModalVisible }) => {
  const { id } = useParams();

  const handleConfirmMakeAdmin = async () => {
    setIsModalVisible(false);
    try {
      await makeAdmin(id);
      message.success("User promoted to admin successfully.");
    } catch (err) {
      message.error(err?.response?.data?.message || "Failed to promote user to admin");
    }
  };

  const handleCancelMakeAdmin = () => {
    setIsModalVisible(false);
  };

  return (
    <Modal
      title="Make User Admin"
      open={isModalVisible}
      onOk={handleConfirmMakeAdmin}
      onCancel={handleCancelMakeAdmin}
      centered
      footer={[
        <Button
          className="primary-button"
          variant="solid"
          onClick={handleCancelMakeAdmin}
        >
          No
        </Button>,
        <Button className="primary-button" onClick={handleConfirmMakeAdmin}>
          Yes
        </Button>,
      ]}
    >
      <p style={{ marginBottom: "25px" }}>
        Are you sure you want to promote this User {id} to Admin?
      </p>
    </Modal>
  );
};

export default MakeAdminModal;
